export default __webpack_public_path__ + "static/media/FAQ_4.4a070e9f.png";